import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  UntypedFormControl,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApilistService } from '../services/apilist.service';
import { CommonService } from '../services/common.service';
import { GlobalService } from '../services/global.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-materialsyllabus',
  standalone: true,
  imports: [
    CommonModule, // ✅ for *ngIf, *ngFor, ngStyle
    FormsModule, // ✅ for [(ngModel)]
    ReactiveFormsModule, // ✅ for reactive forms
  ],
  templateUrl: './materialsyllabus.component.html',
  styleUrls: ['./materialsyllabus.component.scss'],
})
export class MaterialsyllabusComponent implements OnInit {
  display: any = 'none';
  displayDelete: any = 'none';
  subjectName: any;
  year: any;
  category: any;
  cources: any[];
  courseData: any;
  showAdd = false;
  showEdit = false;
  materialdata: any[];
  subjectDetails;
  id: any;

  courseForm: UntypedFormGroup;

  showErr = false;
  deleteErr: any;

  searchval: any;

  error_messages = {
    subjectval: [{ type: 'required', message: 'Please enter Subject' }],
    yearval: [{ type: 'required', message: 'Please enter Year' }],
    categorytypeval: [{ type: 'required', message: 'Please Select Category' }],
  };
  adminName: any;
  adminImage: any;
  allSubject: any;
  allData: any;

  showData = false;
  showNodata = false;

  @ViewChild('boxCourse', { static: false }) boxCourse: ElementRef;
  image: any = [];
  imageTrueFalse: boolean;
  allImages: any;
  allCollegeImages: any;

  constructor(
    public utils: ApilistService,
    public commonservice: CommonService,
    public globalService: GlobalService,
    public formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService
  ) {
    this.courseForm = this.formBuilder.group({
      subjectval: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      yearval: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      categorytypeval: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });

    let admin = JSON.parse(localStorage.getItem('adminDetails'));
    let adminData = JSON.parse(admin);

    this.adminName = adminData[0].name;
    this.adminImage = adminData[0].image;

    if (this.adminImage == null || this.adminImage == undefined) {
      this.adminImage = 'assets/tenant-avatar.jpg';
    }
  }

  deletematerialcategorysyllabus(id) {
    this.spinner.show();
    let payload = {
      id: id,
    };
    const servicePath = this.utils.getApiConfigs('materialcatergorysyllabus');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.globalService.showSuccess('Syllabus Delete Successfully');
          this.display = 'none';
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
        }
      });
  }

  ngOnInit(): void {
    this.spinner.show();

    this.courseForm.reset();

    this.getmaterialcategory();
    this.getsyllabus();
  }

  onMouseOver(e) {
    (<HTMLDivElement>this.boxCourse.nativeElement).style.pointerEvents = 'auto';
    (<HTMLDivElement>this.boxCourse.nativeElement).style.cursor = 'pointer';
  }

  viewImages(index) {
    // console.log(index);
    if (!this.allCollegeImages[index].isShowAll) {
      this.allCollegeImages[index].lessData =
        this.allCollegeImages[index].image;
    } else {
      this.allCollegeImages[index].lessData = this.allCollegeImages[
        index
      ].image.slice(0, 4);
    }
    this.allCollegeImages[index].isShowAll =
      !this.allCollegeImages[index].isShowAll;
  }

  onChangeEvent(event) {
    // console.log("event", event);

    var val = event.target.value;
    // console.log("val", this.category);

    this.allData = this.courseData;

    // console.log("All Data", this.allData);

    if (val) {
      this.allSubject = this.allData.filter((item) =>
        item.category.toLowerCase().includes(val.toLowerCase())
      );
    }

    // console.log("Courses Data", this.allCourse);
    if (this.allSubject == '') {
      this.globalService.showError('No data found');
    }
  }

  reset() {
    this.ngOnInit();
    this.searchval = '';
  }

  addSubject1() {
    this.spinner.show();
    let payload = {
      material_cat_id: this.category,
      subject: this.subjectName,
      year: this.year,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('addsubject');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Subject added Successfully');
          this.display = 'none';
          this.ngOnInit();
          this.courseForm.reset();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          this.display = 'none';
          // console.log("data", resp.data);
        }
      });
  }

  openAdd() {
    this.courseForm.reset();
    this.display = 'block';
    this.showAdd = true;
    this.showEdit = false;
  }

  // editCourse(data){
  //   // console.log("Data", data);
  //   this.display = "block";
  //   this.showAdd = false;
  //   this.showEdit = true;

  //   this.courseName = data.courses;
  //   this.id = data.id;
  // }

  getsyllabus() {
    this.spinner.show();
    const servicePathImages = this.utils.getApiConfigs('materialsyllabuss');
    // // console.log("servicePathCollege",servicePathImages);
    this.commonservice
      .invokeService(servicePathImages[0].method, servicePathImages[0].path, '')
      // const servicePath = this.utils.getApiConfigs('trendingcolleges');
      // this.commonservice.invokeService(servicePath[0].method, servicePath[0].path,"")
      .then((resp: any) => {
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.allImages = resp.data;
          // console.log("All Images",this.allImages);

          if (this.allImages == '') {
            this.showNodata = true;
            this.showData = false;
          } else {
            this.showData = true;
            this.showNodata = false;
          }
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
        }
        this.allCollegeImages = this.allImages;

        console.log('All colleges', this.allCollegeImages);

        for (let i = 0; i < this.allCollegeImages.length; i++) {
          // this.clgImages = this.allCollegeImages[i];
          this.allCollegeImages[i].lessData = this.allCollegeImages[
            i
          ].image.slice(0, 4);
          // console.log("clgimages", this.allCollegeImages[i]);

          // for(let j=0; j<= this.clgImages.length; j++){
          //   this.imageData = this.clgImages[j].images;
          //   console.log("imgs", this.imageData);
          // }
        }
      });
  }

  deleteCourse(data) {
    this.displayDelete = 'block';
    this.deleteErr = '';
    this.id = data.id;
  }

  getmaterialcategory() {
    this.spinner.show();

    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('getcategory');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, '')
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          this.materialdata = resp.data;
          console.log('----------------------', this.materialdata);
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          // console.log("data", resp.data);
        }
      });
  }

  // getmaterialsubject(){
  //   this.spinner.show();
  //   const servicePath = this.utils.getApiConfigs('materialsubject');
  //   this.commonservice.invokeService(servicePath[0].method, servicePath[0].path, '')
  //     .then((resp: any) => {
  //       this.spinner.hide();
  //       if (resp.status_code == "200") {
  //         this.spinner.hide();
  //         this.subjectDetails = resp.data;
  //         console.log("sasdsd",this.subjectDetails)

  //         // console.log("course details", JSON.stringify(this.courseDetails));

  //         if(this.subjectDetails == '' ){
  //           this.showNodata = true;
  //           this.showData = false;
  //         }else{
  //           this.showData = true;
  //           this.showNodata = false;
  //         }
  //       }

  //       this.allSubject = this.subjectDetails;
  //       // console.log("All courses", this.allCourse);
  //     });
  // }

  // updateCourse(){
  //   this.spinner.show();
  //   let payload = {
  //     "courses": this.courseName,
  //     "id": this.id
  //   }
  //   // console.log("payload", payload);
  //   const servicePath = this.utils.getApiConfigs('course');
  //   this.commonservice.invokeService(servicePath[0].method, servicePath[0].path, payload)
  //     .then((resp: any) => {
  //       // console.log("resp", resp);
  //       this.spinner.hide();
  //       if (resp.status_code == "200") {
  //         this.spinner.hide();
  //         // console.log(resp);
  //         this.globalService.showSuccess("Course updated successfully");
  //         this.display = "none";
  //         this.ngOnInit();
  //         this.courseForm.reset();
  //       }else if(resp.status_code == "400"){
  //         this.spinner.hide();
  //         // console.log("data", resp.data);
  //         this.globalService.showError(resp.data);
  //         this.display = "none";
  //       }
  //     });
  // }

  addsyllabus() {
    this.spinner.show();
    let payload = {
      material_cat_id: this.category,

      image: this.image,
    };
    console.log('payload', payload);
    const servicePath = this.utils.getApiConfigs('materialsyllabus');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          // console.log(resp);
          this.spinner.hide();
          this.globalService.showSuccess('Image Added Successfully');
          this.display = 'none';
          this.image = [];
          this.ngOnInit();
          this.courseForm.reset();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          this.globalService.showError(resp.data);
          // console.log("data", resp.data);
        }
      });
  }
  handleFileInput(event) {
    // console.log("event", event.target.files);

    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;

      for (let i = 0; i < filesAmount; i++) {
        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.image.push(event.target.result);
          console.log(this.image);
          this.imageTrueFalse = true;
        };
        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }

  onCloseHandled() {
    this.display = 'none';
    this.displayDelete = 'none';
  }

  delete() {
    this.spinner.show();
    let payload = {
      id: this.id,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('deletecourses');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // console.log(resp);
          this.globalService.showSuccess('Course deleted successfully');
          this.displayDelete = 'none';
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.data);
          this.showErr = true;
          this.deleteErr = resp.message;
        }
      });
  }
}
